module.exports = __webpack_public_path__ + "0539c0c5048a066b66275bb86994ef8d.svg";